import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IScheduleItemOverride } from 'src/interfaces/Schedule';
import { queryKeys, requestCCApi, ScheduleDetailsParams } from 'src/utils';

export const useCreateScheduleItemOverrides = () => {
  return useMutation({
    mutationFn: createScheduleItemOverrides,
    onSuccess: (_, variables) => {
      const {
        currentSidebarDetailsDataParams,
        overridePositions,
        locationGroupId,
      } = variables;

      // clear cache of calendar endpoint under the updated individual OO location
      queryClient.invalidateQueries(
        queryKeys.getCalendarEvents.details([
          locationGroupId,
          currentSidebarDetailsDataParams?.locationCode,
        ]),
      );

      // clear cache of scheduleDetails endpoint when selecting all
      queryClient.invalidateQueries(
        queryKeys.getCalendarSidebarDetails.details([
          JSON.stringify(currentSidebarDetailsDataParams),
        ]),
      );

      // clear cache of scheduleDetails endpoint for the affected positions
      overridePositions?.forEach((position) => {
        queryClient.invalidateQueries(
          queryKeys.getCalendarSidebarDetails.details([
            JSON.stringify({
              ...currentSidebarDetailsDataParams,
              position: String(position),
            }),
          ]),
        );
      });
      queryClient.invalidateQueries(queryKeys.scheduleOverview.invalidateAll());
      queryClient.invalidateQueries(queryKeys.schedules.invalidateAll());
      queryClient.invalidateQueries(queryKeys.schedulePreview.invalidateAll());
    },
  });
};

const createScheduleItemOverrides = async (payload: {
  overrides: IScheduleItemOverride[];
  currentSidebarDetailsDataParams?: ScheduleDetailsParams;
  overridePositions?: number[];
  locationGroupId?: string;
}) => {
  const { overrides } = payload;
  const response = await requestCCApi({
    url: '/scheduleItemOverrides',
    method: 'POST',
    data: { data: overrides },
  });

  return response;
};
